import React from "react";
import PropTypes from "prop-types";
import "../css/charts.css";

const SEGMENT_LABELS = {
  noSolution: "No Solution",
  lowSolution: "Low Solution",
  solution: "Full Solution",
};

const StackedBarChart = ({ title, data, labelKey }) => {
  if (!data || data.length === 0) return null;

  const palette = ["#f97316", "#facc15", "#22c55e"];
  const segments = ["noSolution", "lowSolution", "solution"];

  return (
    <div className="chart-card">
      <h3 className="chart-title">{title}</h3>
      <div className="hint-level-chart">
        {data.map((item, index) => {
          const totals = segments.map((segment) => item[segment] || 0);
          const sum = totals.reduce((acc, value) => acc + value, 0) || 1;

          return (
            <div key={`hint-bar-${index}`} className="hint-level-row">
              <div className="hint-level-label">
                <span>{item[labelKey]}</span>
                <strong>{sum}</strong>
              </div>
              <div className="hint-level-bar">
                {segments.map((segment, segIndex) => {
                  const value = totals[segIndex];
                  const width = (value / sum) * 100;
                  return (
                    <div
                      key={`${segment}-${index}`}
                      className={`hint-level-segment ${segment}`}
                      style={{ width: `${width}%`, backgroundColor: palette[segIndex] }}
                      title={`${SEGMENT_LABELS[segment]}: ${value}`}
                    >
                      {width > 12 && <span>{value}</span>}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <div className="hint-level-legend">
        {segments.map((segment, index) => (
          <div key={`legend-${segment}`} className="legend-item">
            <div className="legend-color" style={{ backgroundColor: palette[index] }} />
            <span>{SEGMENT_LABELS[segment]}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

StackedBarChart.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  labelKey: PropTypes.string.isRequired,
};

export default StackedBarChart;
